import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Commons } from "../../helper/CommonService";
import { API_HOST, FILTER_TYPE, KETERSEDIAAN } from "../../helper/Constant";
import { Card, CardContent, CardHeader, Skeleton } from "@mui/material";
import DialogProgress from "../../components/Dialogs/DialogProgress";
import FilterAdm from './component/Filter';


const columns = [
    { field: 'no_daftar', headerName: 'No Daftar', width: 100 },
    { field: 'nama', headerName: 'Nama', width: 150 },
    {
        field: 'isIsi_formulir', headerName: 'Isi Formulir', width: 100,
        valueGetter: (value, row) => {
            return row.isIsi_formulir ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
        }
    },
    {
        field: 'isBayar_pendaftaran', headerName: 'Bayar Pendaftaran', width: 130,
        valueGetter: (value, row) => {
            return row.isBayar_pendaftaran ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
        }
    },
    {
        field: 'isUpload_berkas', headerName: 'Upload Berkas', width: 130,
        valueGetter: (value, row) => {
            return row.isUpload_berkas ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
        }
    },
    {
        field: 'isBerkas_verified', headerName: 'Berkas Terverifikasi', width: 130,
        valueGetter: (value, row) => {
            return row.isBerkas_verified ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
        }
    },
    {
        field: 'isUndangan_ujian', headerName: 'Undangan Ujian', width: 130,
        valueGetter: (value, row) => {
            return row.isUndangan_ujian ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
        }
    },
    {
        field: 'isUjian_seleksi', headerName: 'Ujian Seleksi', width: 130,
        valueGetter: (value, row) => {
            return row.isUjian_seleksi ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
        }
    },
    {
        field: 'isLulus', headerName: 'Lulus Ujian', width: 130,
        valueGetter: (value, row) => {
            return row.isLulus ? "Ya" : "Tidak"
        }
    },
    {
        field: 'isHasil_pengumuman', headerName: 'Hasil Pengumuman', width: 130,
        valueGetter: (value, row) => {
            return row.isHasil_pengumuman ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
        }
    },
    {
        field: 'isBayar_daftar_ulang', headerName: 'Bayar Daftar Ulang', width: 150,
        valueGetter: (value, row) => {
            return row.isBayar_daftar_ulang ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
        }
    },
];

const paginationModel = { page: 0, pageSize: 100 };

function Progress() {

    const [santriProgress, setSantriProgress] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    const [loading, setLoading] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);

    const PopulateProgressDataRow = (santries, progresses, dataLain, dataAyah, dataIbu, dataWali) => {
        return santries.map((santri) => {
            let findProgress = progresses.find((progress) => progress.id === santri.id);
            let getDataLain = dataLain?.find((x) => x.id === santri.id);
            let getAyah = dataAyah?.find((x) => x.id === santri.id);
            let getIbu = dataIbu?.find((x) => x.id === santri.id);
            let getWali = dataWali?.find((x) => x.id === santri.id);
            let getWaNo = Commons.GetNoWa(getDataLain, getAyah, getIbu, getWali);
            return {
                id: santri.id,
                no_daftar: santri.no_daftar,
                nama: santri.nama,
                isIsi_formulir: findProgress?.isIsi_formulir,
                isBayar_pendaftaran: findProgress?.isBayar_pendaftaran,
                isUpload_berkas: findProgress?.isUpload_berkas,
                isBerkas_verified: findProgress?.isBerkas_verified,
                isUndangan_ujian: findProgress?.isUndangan_ujian,
                isUjian_seleksi: findProgress?.isUjian_seleksi,
                isLulus: findProgress?.isLulus,
                isHasil_pengumuman: findProgress?.isHasil_pengumuman,
                isBayar_daftar_ulang: findProgress?.isBayar_daftar_ulang,
                waNo: getWaNo
            }
        });
    }
    const RunFilter = (fieldName, filterValue) => {
        setLoading(true);
        LoadData()
            .then(([resSantri, resProgress]) => {
                let filterSantri = PopulateProgressDataRow(resSantri, resProgress);
                if (fieldName) {
                    filterSantri = filterSantri.filter((santri) => {
                        if (santri[fieldName] === undefined) {
                            return false;
                        }
                        return (santri[fieldName].toString().toUpperCase().includes(filterValue.toUpperCase()))
                    })
                }
                setSantriProgress(filterSantri);
            }).finally(() => {
                setLoading(false);
            });
    }
    const HandleDialogClose = (e) => {
        setDialogOpen(false);
    }

    const ChangeValidasiBerkas = (e, id) => {
        setSantriProgress((prev) =>
            prev.map((item) =>
                item.id === id ? {
                    ...item,
                    [e.target.name]: (e.target.checked) ? true : false
                } : item
            ));
    }

    const ShowTable = () => {
        if (loading) {
            return (<>
                <Skeleton variant="rectangular" width={"100%"} height={100} />
            </>)
        }
        return (
            <>
                <DataGrid
                    rows={santriProgress}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5, 10]}
                    checkboxSelection
                    onRowClick={(e) => {
                        setSelectedRow(e.row);
                        setDialogOpen(true);
                    }}
                    disableMultipleRowSelection={true}
                    sx={{ border: 0 }}
                />
            </>
        );
    }

    const LoadData = () => {
        return Promise.all([
            Commons.GetData(API_HOST + "/santri", "", true),
            Commons.GetData(API_HOST + "/progress", "", true),
            Commons.GetData(API_HOST + "/datalain", "", true),
            Commons.GetData(API_HOST + "/ayah", "", true),
            Commons.GetData(API_HOST + "/ibu", "", true),
            Commons.GetData(API_HOST + "/wali", "", true)
        ]);

    };

    useEffect(() => {
        setLoading(true);
        LoadData()
            .then(([resSantri, resProgress, resDataLain, resAyah, resIbu, resWali]) => {
                setSantriProgress(PopulateProgressDataRow(resSantri, resProgress, resDataLain, resAyah, resIbu, resWali));
            })
            .catch((resErr) => {
                console.log(resErr);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <>
            <Card>
                <CardHeader title="Progress Management" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    <DialogProgress handleClose={HandleDialogClose} handleDataChange={ChangeValidasiBerkas} isOpen={dialogOpen} rowDetail={santriProgress.find((santri) => { return santri.id === selectedRow.id })} ></DialogProgress>
                    <FilterAdm RunFilter={RunFilter} FilterTypeSudah={FILTER_TYPE.PROGRESS_SUDAH} FilterTypeBelum={FILTER_TYPE.PROGRESS_BELUM}></FilterAdm>
                    {ShowTable()}
                </CardContent>
            </Card>
        </>
    );
}

export default Progress;